import { NEWS } from '~/consts';

export const state = () => ({
  all: []
})

export const mutations = {
  setAll(state, val) {
    state.all = val;
  }
}

export const actions = {
  getAll({ commit }) {
    const vm = this;

    vm.loading_get_news = true;

    this.$axios.post(NEWS.GET_ALL).then(({ data }) => {
      if (data.applicationSystem.code == 0) {
        let news = collect(data.data).sortByDesc('created_at').toArray();
        commit('setAll', news);
      }
    }).catch(() => {
    });
  },
}
